export default __webpack_public_path__ + "locales/en/About.json?hash=d230f69bd2f5d24ecdd9987cdde582ee";